/* src/app/components/core/layout/header/header.component.css */
.header-container {
  top: 0;
  display: grid;
  grid-template-columns: auto 1fr auto;
  width: 100%;
  align-items: center;
  position: absolute;
  background: #004C4A;
  padding: 8px 12px;
  box-sizing: border-box;
  gap: 16px;
  z-index: 100;
}
.cpyname {
  color: #FFF;
  font-size: 1.429rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.header-center {
  display: flex;
  align-items: center;
  gap: 24px;
  min-width: 0;
}
.program-divider {
  width: 2px;
  height: 32px;
  background: rgba(255, 255, 255, 0.3);
  margin: 0 8px;
}
.city {
  display: flex;
  align-items: center;
  gap: 8px;
}
.cityName {
  color: var(--material-theme-sys-light-on-primary, #FFF);
  font-family: Outfit;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  min-width: 0;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0 0 0 10px;
  min-width: 0;
}
.user-name {
  color: #FFF;
  font-family: Outfit;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-role {
  color: rgba(255, 255, 255, 0.8);
  font-family: Outfit;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.logout-btn {
  display: flex;
  padding: 6px 12px;
  height: 40px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 24px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: Outfit;
  font-size: 0.9rem;
  color: #FFF;
  font-weight: 500;
}
.logout-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
}
.logout-btn:active {
  background: rgba(255, 255, 255, 0.15);
}
.logout-btn:focus-visible {
  outline: 2px solid #FFF;
  outline-offset: 2px;
}
.logout-btn .header-icon {
  font-size: 1.4rem;
  line-height: 1;
}
.logout-text {
  display: inline;
}
@media (max-width: 1024px) {
  .logout-text {
    display: none;
  }
  .logout-btn {
    padding: 0;
    width: 40px;
    gap: 0;
  }
  .logout-btn .header-icon {
    display: block;
    width: 1.4rem;
    height: 1.4rem;
    text-align: center;
    line-height: 1.4rem;
  }
}
.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}
.header-right .d-flex {
  display: flex;
  align-items: center;
  gap: 8px;
}
.header-tooltip {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.header-tooltip::after {
  content: attr(data-tooltip);
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1;
  padding: 6px 10px;
  border-radius: 8px;
  background: #004C4A;
  color: #FFF;
  border: 2px solid rgba(255, 255, 255, 0.3);
  box-sizing: border-box;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  z-index: 1000;
}
.header-tooltip:hover::after,
.header-tooltip:focus-within::after {
  opacity: 1;
  visibility: visible;
}
.header-right .d-flex ppl-google-translate,
.header-right .d-flex ppl-menu-drop-button,
.header-right .d-flex ppl-notifications {
  display: flex;
  align-items: center;
  justify-content: center;
}
::ng-deep .header-right ppl-menu-drop-button .menu-drop-button {
  background: rgba(255, 255, 255, 0.1) !important;
  border: 2px solid rgba(255, 255, 255, 0.3) !important;
  border-radius: 24px !important;
  color: #FFF !important;
  transition: all 0.2s ease !important;
}
::ng-deep .header-right ppl-menu-drop-button .menu-drop-button:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}
.header-right .user-info {
  border-left: 2px solid rgba(255, 255, 255, 0.3);
}
.header-left {
  display: flex;
  align-items: center;
  cursor: pointer !important;
  border: inherit;
  background: inherit;
  padding: 0;
}
.logo {
  height: 32px;
  margin-right: 20px;
}
.profile {
  display: flex;
  align-items: center;
  gap: 24px;
  align-self: stretch;
}
.line {
  width: 100%;
  height: 3px;
  background: #11B8AE;
}
.action {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
@media (max-width: 768px) {
  .header-container {
    padding: 6px 8px;
    gap: 8px;
    grid-template-columns: auto 1fr auto;
  }
  .cpyname {
    font-size: 1.1rem;
  }
  .header-center {
    gap: 8px;
  }
  .program-divider {
    display: none;
  }
  .cityName {
    display: inline;
    font-size: 0.85rem;
  }
  .user-info {
    padding: 0;
    border-left: none !important;
    display: flex;
    gap: 2px;
  }
  .user-name {
    font-size: 0.7rem;
  }
  .user-role {
    font-size: 0.6rem;
  }
  .logout-btn {
    padding: 0;
    font-size: 0.75rem;
    gap: 0;
    width: 40px;
  }
  .logout-btn .header-icon {
    font-size: 1.2rem;
    display: block;
    width: 1.2rem;
    height: 1.2rem;
    text-align: center;
  }
  ::ng-deep .header-right ppl-menu-drop-button .menu-drop-button {
    padding: 6px 10px !important;
    font-size: 0.8rem !important;
  }
  .logo {
    height: 28px;
    margin-right: 12px;
  }
}
@media (max-width: 600px) {
  .header-container {
    padding: 4px 6px;
    gap: 12px;
    grid-template-columns: auto 1fr auto;
  }
  .cpyname {
    font-size: 0.95rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .header-center {
    display: flex;
    gap: 6px;
    align-items: center;
    min-width: 0;
    margin-right: auto;
  }
  .city {
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
  }
  .cityName {
    display: inline;
    font-size: 0.75rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 12px;
  }
  .logo {
    height: 24px;
    margin-right: 6px;
    flex-shrink: 0;
  }
  .user-info {
    display: none;
  }
  .logout-btn {
    padding: 0;
    font-size: 0.7rem;
    flex-shrink: 0;
    height: 32px;
    width: 32px;
    gap: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .logout-btn .header-icon {
    font-size: 1.2rem;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.2rem;
    height: 1.2rem;
  }
  ::ng-deep .header-right ppl-menu-drop-button .menu-drop-button {
    padding: 6px 10px !important;
    font-size: 0.65rem !important;
    height: 32px !important;
    gap: 4px !important;
  }
}
@media (max-width: 390px) {
  .header-container {
    padding: 4px;
    gap: 6px;
  }
  .header-right {
    gap: 6px;
    min-width: 0;
  }
  .header-right .d-flex {
    gap: 4px;
    margin-right: 0 !important;
    flex-shrink: 0;
  }
  .header-center {
    gap: 4px;
  }
  .city {
    min-width: 0;
    max-width: 120px;
    gap: 2px;
  }
  .cityName {
    max-width: 92px;
    margin-right: 4px;
    font-size: 0.7rem;
  }
  ::ng-deep .header-right ppl-menu-drop-button .menu-drop-button {
    padding: 4px 8px !important;
    font-size: 0.6rem !important;
    height: 30px !important;
    min-width: auto !important;
    gap: 2px !important;
  }
  .logout-btn {
    width: 30px;
    height: 30px;
  }
  .logout-btn .header-icon {
    font-size: 1.05rem;
    width: 1.05rem;
    height: 1.05rem;
  }
}
/*# sourceMappingURL=header.component-B4NV3GKP.css.map */
